<div>
	<div class="flex justify-between">
		<div class="flex gap-0.5">
			<h3 class="h3">Welcome To Sync By Closer</h3>
		</div>
		<div class="flex gap-4 items-center">
			<p class="text-xs text-gray-500">
				{{
					(userIsAdmin$ | async) || currentStep == 1
						? currentStep
						: currentStep - 1
				}}
				of
				{{ (userIsAdmin$ | async) ? numSteps : numSteps - 1 }}
			</p>
			<ui-button
				icon="x"
				preset="ICON_DEFAULT"
				(click)="closeModal()"
			></ui-button>
		</div>
	</div>
	<hr />
	<div class="flex flex-col gap-8 py-8" [ngSwitch]="currentStep">
		<div class="flex flex-col gap-8">
			<ng-container *ngSwitchCase="1">
				<div class="flex flex-col text-center items-center justify-center">
					<img
						class="w-[90px] h-[80px] mb-8"
						src="/assets/images/integrations/sync-logo.png"
					/>
					<h4 class="h4">Step 1: Send lawyer an Invite to connect</h4>
					<p class="p-sm">
						The sign-up process for Sync is exclusively for lawyers. They are
						required to complete a brief onboarding process, which includes
						adding a digital signature to Sync, creating an access PIN for the
						signature, and ensuring their instructions are routed to their LSO
						fax number.
					</p>

					<img
						class="mt-6 w-[250px] h-[200px]"
						src="/assets/images/integrations/sync-girl-with-paper-plane.svg"
					/>
				</div>
			</ng-container>

			<ng-container *ngSwitchCase="2">
				<div class="flex flex-col text-center items-center justify-center">
					<img
						class="w-[90px] h-[80px] mb-8"
						src="/assets/images/integrations/sync-logo.png"
					/>
					<h4 class="h4">
						Step 2: While lawyer accounts are being setup,<br />
						add your firm's trust account details
					</h4>
					<p class="p-sm">
						Add your firm's trust account details and local branches in the new
						Funding<br />
						Methods tab in business settings.
					</p>

					<img
						class="mt-6 w-[250px] h-[200px]"
						src="/assets/images/integrations/sync-girl-holding-notification.svg"
					/>
				</div>
			</ng-container>

			<ng-container *ngSwitchCase="3">
				<div class="flex flex-col text-center items-center justify-center">
					<img
						class="w-[90px] h-[80px] mb-8"
						src="/assets/images/integrations/sync-logo.png"
					/>
					<h4 class="h4">
						Step {{ (userIsAdmin$ | async) ? '3' : '2' }}: Upload instructions
						to the Mortgage Inbox
					</h4>
					<p class="p-sm">
						Once you receive faxed instructions, you're all set! You can upload
						them into<br />
						the Sync mortgage inbox for digital processing.
					</p>

					<img
						class="mt-6 w-[250px] h-[200px]"
						src="/assets/images/integrations/sync-man-cloud-upload.svg"
					/>
				</div>
			</ng-container>
		</div>
	</div>
	<hr />
	<footer class="flex justify-end pt-4">
		<ui-button
			[label]="currentStep === numSteps ? 'Done' : 'Next'"
			(click)="nextStep()"
		></ui-button>
	</footer>
</div>
